import { render, staticRenderFns } from "./FormReembolso.vue?vue&type=template&id=30063573&scoped=true"
import script from "./FormReembolso.vue?vue&type=script&lang=js"
export * from "./FormReembolso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30063573",
  null
  
)

export default component.exports